export class SimplemdeConfig {
  public style?: 'default';
  public delay?: number;
  public options?: { [key: string]: any };
}
